import { DomestikaPushNotification } from "./pushNotification";

const pushNotification = DomestikaPushNotification.create();

export { pushNotification };
